<div class="hide-acc">
  <div class="container-box manage-license">
    <h1 class="manage-product">Manage products</h1>
    <div class="alert valign-children-middle" *ngIf="manageLicenseError!=''">
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2>Something isn't working</h2>
        <p>{{manageLicenseError}}</p>
      </div>
    </div>
    <div class="alert valign-children-middle" *ngIf="manageLicenseInfo!=''">
      <div class="alert-info" aria-label="Information">
        <i class="icon-flat-info"></i>
      </div>
      <div>
        <h2>{{manageLicenseInfo}}</h2>
      </div>
    </div>
    <div class="alert valign-children-middle" *ngIf="companyNotFound">
      <div class="alert-info" aria-label="Information">
        <i class="icon-flat-info"></i>
      </div>
      <div>
        <h2>No company found. Please place an order to manage products.</h2>
      </div>
    </div>
    <div *ngIf="reviewComponentSuccessMessageFlag">
      <div class="alert valign-children-middle">
        <div class="alert-success" aria-label="Success">
          <i class="icon-approval" aria-hidden="true"></i>
        </div>
        <div>
          <h2>Success</h2>
          <h2>{{reviewComponentSuccessMessage}}</h2>
        </div>
      </div>
    </div>
    <div *ngIf="totalRecords > 0">
      <section class="col-md-12 col-sm-12 manage-icon-img" *hasPermission="multipleUserLink">
        <i class="icon-people-usercheck icon-size"></i><a href="javascript:void(0)" (click)="assignUnassignWizard()"> Assign multiple products to a user</a>
        <div class="clearfix"></div>
      </section>
    </div>
    <div class="clearfix"></div>
    <section class="license-product" *ngFor=" let license of licenseMap | mapToIterable ">
     <h2>{{license.key}}</h2>
	 
	 <div  *ngFor="let fanMap of license.val|fanMapToIterable">
		 <div *ngFor="let card of fanMap.val">
		  <span *ngIf="card.isSingleQuantity == false" >
		  <a href="javascript:void(0)" class="bill-under-text" (click)="buyUnderDiffCTn(license)" >Bill to a different wireless number </a>  
		  </span>
		</div>
	</div>
	
     <section class="fan-card" *ngFor="let fanMap of license.val|fanMapToIterable">
        <p class="col-sm-12"><strong>Foundation account: </strong> <span>{{fanMap.key}} </span></p>
		
		

       <div class="clearfix"></div>
        <div *ngIf="licenseArray[fanMap.key]" class="row msg">Another administrator in your organization has already purchased this product. However, the licenses are managed
          under an account you don't have access to. To use this product, you must purchase licenses and bill them to an
          account you manage.</div>
        <div class="clearfix"></div>
        <div class="row">
          <div class="row-box display-column">
            <article class="license-tile" *ngFor="let card of fanMap.val" [ngClass]="{'check-fan': licenseArray[fanMap.key]}">
              <app-manage-licenses-card [singlelicense]="card" (reviewComponentSuccessMessageFlagValue)="reviewComponentSuccessMessageFlagValue($event)"
                (showEditAssignModelPopUp)="showEditAssignModelPopUp($event)"></app-manage-licenses-card>
            </article>
          </div>
        </div>
      </section>
    </section>
    <div *ngIf="totalRecords > 0" class="row pagination">
      <app-pagination [startIndex]="startIndex" [totalRecords]="totalRecords" [recordsPerPage]="recordsPerPage" (pageChange)="onPageChange($event)"></app-pagination>
    </div>
  </div>
  <app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
</div>
<div *ngIf="licenseFlag">
  <app-modal [showModal]="licenseFlag" [modalCoverClass]="modalCoverClass" [modalClass]="modalClass">
    <form [formGroup]="licenseForm" (keydown)="handleKeydown($event)" autocomplete="off">
      <div #assign>
        <header class="popup-header">
          <h2 id="modalHeader" tabindex=0>
            <span *ngIf="assignProductFlag">Assign a name</span>
            <span *ngIf="editNameFlag">Change license group name</span>
          </h2>
        </header>
        <div class="corner-button">
          <button type="button" class="close" aria-label="Close" (click)="cancel(false)" tabindex="0">x</button>
        </div>
        <div class="popup-body">
          <h2>{{singlelicense?.specName}}</h2>
          <hr/>
          <div><strong>Foundation account: </strong>{{singlelicense?.brokerAccountClientId}}</div>
          <p><strong>Wireless number: </strong>{{singlelicense?.billingClientId}}</p>
          <div class="row assign-prod" *ngIf="assignProductFlag">
            <label for="worforce" class="col-md-12">Enter a license group name (optional)</label>
            <label class="col-md-12">(Example: Marketing team)</label>
          </div>
          <div *ngIf="editNameFlag">
            <div class="current-prod"><strong>Current license group name: </strong><span>{{singlelicense?.productDesc}}</span></div>
            <div class="form-group">
              <label for="newname" class="col-sm-12 col-md-12" [ngClass]="{'error-field': formErrors.productName}">New license group name</label>
            </div>
          </div>
          <div class="row">
            <label for="workforce"><div class="hide-element">workforce</div></label>
            <div class="col-sm-12 col-md-6"><input aria-label="workforce" [attr.aria-describedby]="formErrors.productName ? 'license-name' : null" formControlName="productName"
                class="form-control" type="text" maxlength="40" id="workforce" [class.text-error]="formErrors.productName"></div>
          </div>
          <div id="license-name" class="text-danger" *ngIf="formErrors.productName">
            {{formErrors.productName}}
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="text-right popup-footer">
          <hr/>
          <button type="submit" class="btn btn-secondary btn-click text-center" [checkImpersonator]="!licenseForm.valid || csrPermissionLicenseCardAssignButton"
            (click)="assignButton($event)">Assign</button>
          <a href="javascript:void(0)" class="btn btn-link text-center" (click)="cancel(false)">Cancel</a>
        </div>
      </div>
    </form>
  </app-modal>
</div>
